export const getPartialMaskedPos = (rawValue: string, maskWithoutSpecialChars: string[], cursorPos: number): number => {
  let maskedPos = 0;
  for (let i = 0; i < cursorPos; i += 1) {
    if (maskWithoutSpecialChars[maskedPos] === rawValue[i]) maskedPos += 1;
  }
  return maskedPos;
};
